import React from 'react';
import { Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { 
  Popover, 
  PopoverContent, 
  PopoverTrigger 
} from '@/components/ui/popover';
import { useNotifications } from '@/hooks/use-notifications';
import NotificationList from './notification-list';
import { Badge } from '@/components/ui/badge';

export default function NotificationBell() {
  const { 
    notifications, 
    isLoading, 
    unreadCount, 
    markAsRead, 
    deleteNotification 
  } = useNotifications();
  
  const [open, setOpen] = React.useState(false);
  
  // Mark all notifications as read when popover is opened
  React.useEffect(() => {
    if (open && unreadCount > 0) {
      notifications
        .filter(notification => !notification.read)
        .forEach(notification => markAsRead(notification.id));
    }
  }, [open, unreadCount, notifications, markAsRead]);
  
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="sm" className="relative h-8 w-8 rounded-full">
          <Bell className="h-5 w-5" />
          {unreadCount > 0 && (
            <Badge 
              className="absolute -top-1 -right-1 h-5 w-5 rounded-full p-0 flex items-center justify-center" 
              variant="destructive"
            >
              {unreadCount > 9 ? '9+' : unreadCount}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-0" align="end">
        <div className="p-4 border-b">
          <h3 className="font-medium text-sm">Notifications</h3>
        </div>
        <NotificationList 
          notifications={notifications} 
          isLoading={isLoading}
          onDelete={deleteNotification}
        />
      </PopoverContent>
    </Popover>
  );
}